import { VersionStr } from "../../../logic/Versions"
import { Page } from "../../types"

type ClientCSharpPackageReferenceProps = {
    os: string
}

const CSPROJ = () => {
    const xml = 
`<ItemGroup>
<PackageReference Include="Gurobi.Optimizer" Version="${VersionStr}" />
</ItemGroup>`
    return <>
        <h3>Using an editor like VSCode</h3>
        <p>Add the following lines to your project file (with <code>csproj</code> extension):</p>
        <pre>{xml}</pre>
    </>
}

const VSWIN = <>
    <h3>Using Visual Studio 2022 for Windows</h3>
    <p>
    <ul>
            <li>Right-click your project in the Solution Explorer.</li>
            <li>Click "Manage NuGet packages..."</li>
            <li>In the search box, type <code>Gurobi.Optimizer</code></li>
            <li>In the list, select the <code>Gurobi.Optimizer</code> package</li>
            <li>Click the "Install" button</li>
            <li>Accept the terms</li>
        </ul>
    </p>
</>

const VSMAC = <>
    <h3>Using Visual Studio 2022 for MacOS</h3>
    <p>
        <ul>
            <li>Right-click your project in the Solution Explorer.</li>
            <li>Click "Manage NuGet packages..."</li>
            <li>In the search box, type <code>Gurobi.Optimizer</code></li>
            <li>In the list, check the checkbox next to <code>Gurobi.Optimizer</code></li>
            <li>Click the "Add package" button</li>
            <li>Accept the terms</li>
        </ul>
    </p>
</>

const render = ({ os } : ClientCSharpPackageReferenceProps) => {
    return <>
        <p>Gurobi is made available as a NuGet package that must be referenced by your project in order to use the Gurobi API.</p>
        {os == 'windows' && VSWIN}
        {os == 'macos' && VSMAC}
        {CSPROJ()}
    </>
}

const ClientCSharpPackageReference : Page<ClientCSharpPackageReferenceProps> = { key: 'client-csharp-package-reference', title: 'Add Gurobi package reference', render }

export default ClientCSharpPackageReference